export function randomValue() {
  return Math
    .floor((1 + Math.random()) * 0x10000)
    .toString(16)
    .substring(1);
}

export function setCookie(name, value, options = {}) {  
  options = {
    path: '/',
    // add other defaults here if necessary
    ...options
  };
  if (options.expires instanceof Date) {
    options.expires = options.expires.toUTCString();
  }

  let updatedCookie = encodeURIComponent(name) + "=" + encodeURIComponent(value);
  for (let optionKey in options) {
    updatedCookie += "; " + optionKey;
    let optionValue = options[optionKey];
    if (optionValue !== true) {
      updatedCookie += "=" + optionValue;
    }
  }
  document.cookie = updatedCookie;
}

// Reference https://www.w3schools.com/js/js_cookies.asp
export function getCookie(name) {
  let n = name + '=';
  let decodedCookie = decodeURIComponent(document.cookie);
  let val = decodedCookie.split(';');
  for(let i = 0; i <val.length; i++) {
    let char = val[i];
    while (char.charAt(0) == ' ') {
      char = char.substring(1);
    }
    if (char.indexOf(n) == 0) {
      return char.substring(n.length, char.length);
    }
  }
  return '';
}

export const monthAbbr = [
  "Jan", "Feb", "Mar", "Apr",
  "May", "Jun", "Jul", "Aug",
  "Sep", "Oct", "Nov", "Dec",
];

export function buildFormDataForImageUploads(values) {
  const formData = new FormData();
  for (const key in values) {
    const val = values[key];
    const keys = key.split("_");

    if (key === "video_url") {
      if (!val) {
        continue
      }

      if (val && val.length === 0) {
        continue;
      }
    }

    if (key !== "video_url" && keys[keys.length-1] === "url") {
      keys.pop()
      let _key;
      if (key === "author_profile_image_url") {
        _key = "author_profile_image";
      } else {
        _key = keys.join("_");
      }

      if (_key === "hero_image" || _key === "author_profile_image") {
        if (typeof(val) === "string") {
          if (val.length > 0) {
            continue;
          }
          if (val.length === 0) {
            formData.append(`course[${_key}]`, val);
            continue
          }
        }

        if (!val) {
          continue;
        }
      }

      formData.append(`course[${_key}]`, val);
      continue;
    }

    formData.append(`course[${key}]`, val);
  }
  return formData;
}
